"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchUserAppAttributeRequestStatus = exports.getUpdateUserAppAttributeRequestStatus = exports.getFetchSettingsUserAppAttributesRequestStatus = exports.getFetchUserAppAttributesRequestStatus = exports.getUsersAndTeamsOnboardingState = exports.getOnBoardingItemSeen = exports.getUserAppAttribute = exports.getUserAppAttributes = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/RequestStatuses/selectors");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _constants = require("./constants");

var getUserAppAttributes = function getUserAppAttributes(state) {
  return state.userAppAttributes;
};

exports.getUserAppAttributes = getUserAppAttributes;

var getUserAppAttribute = function getUserAppAttribute(key) {
  return (0, _reselect.createSelector)([getUserAppAttributes], function (userAppAttributes) {
    return userAppAttributes.find(function (attr) {
      return attr.get(_constants.KEY) == key;
    });
  });
};

exports.getUserAppAttribute = getUserAppAttribute;

var getOnBoardingItemSeen = function getOnBoardingItemSeen(key) {
  return function (state) {
    var attr = getUserAppAttribute(key)(state);

    if (attr === undefined) {
      return false;
    }

    return attr.get(_constants.VALUE) === 'true';
  };
};

exports.getOnBoardingItemSeen = getOnBoardingItemSeen;

var getUsersAndTeamsOnboardingState = function getUsersAndTeamsOnboardingState(state) {
  var attr = getUserAppAttribute(_constants.USERS_AND_TEAMS_ONBOARDING)(state);

  if (attr === undefined) {
    return false;
  }

  return attr.get(_constants.VALUE);
};

exports.getUsersAndTeamsOnboardingState = getUsersAndTeamsOnboardingState;
var getFetchUserAppAttributesRequestStatus = (0, _getRequestStatus.default)(_actions.UserAppAttributeActionTypes.FETCH_ATTRIBUTES);
exports.getFetchUserAppAttributesRequestStatus = getFetchUserAppAttributesRequestStatus;
var getFetchSettingsUserAppAttributesRequestStatus = (0, _getRequestStatus.default)(_actions.UserAppAttributeActionTypes.FETCH_SETTINGS_ATTRIBUTES);
exports.getFetchSettingsUserAppAttributesRequestStatus = getFetchSettingsUserAppAttributesRequestStatus;
var getUpdateUserAppAttributeRequestStatus = (0, _getRequestStatus.default)(_actions.UserAppAttributeActionTypes.UPDATE_ATTRIBUTE);
exports.getUpdateUserAppAttributeRequestStatus = getUpdateUserAppAttributeRequestStatus;

var getFetchUserAppAttributeRequestStatus = function getFetchUserAppAttributeRequestStatus(key) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.UserAppAttributeActionTypes.FETCH_ATTRIBUTES + "&" + _constants.KEY + "=" + key) || _RequestStatusTypes.default.UNITIALIZED;
  });
};

exports.getFetchUserAppAttributeRequestStatus = getFetchUserAppAttributeRequestStatus;